module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDkgMTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjM1OTE3IDQuNTA1OTJDOC4zNTkxNyA2LjcyNjQyIDYuNTkxODIgOC41MTE4NCA0LjQyOTU5IDguNTExODRDMi4yNjczNiA4LjUxMTg0IDAuNSA2LjcyNjQyIDAuNSA0LjUwNTkyQzAuNSAyLjI4NTQyIDIuMjY3MzYgMC41IDQuNDI5NTkgMC41QzYuNTkxODIgMC41IDguMzU5MTcgMi4yODU0MiA4LjM1OTE3IDQuNTA1OTJaIiBzdHJva2U9IiM4RTk1OUEiLz4KPGNpcmNsZSBjeD0iNC41IiBjeT0iNC41IiByPSIyLjUiIGZpbGw9IiNDQkNFRDEiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popularParlays/leg-icon-grey.svg
// module id = bQKC
// module chunks = 13